<!-- 角色管理组件 -->
<template>
  <div class="role-management">
    <div class="panel-header">
      <span class="panel-title">角色管理</span>
    </div>

    <!-- 操作按钮 -->
    <div class="role-operations">
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="handleAddRole"
        style="flex: 1;"
        class="border-btn-green"
      >新增</el-button>
      <el-button
        size="small"
        icon="el-icon-delete"
        @click="handleDeleteRole"
        :disabled="!selectedRoleId || isDeleteDisabled"
        style="flex: 1;"
       class="border-btn-red">删除</el-button>
    </div>

    <!-- 角色列表导航 -->
    <div class="role-list">
      <div
        v-for="role in roleList"
        :key="role.id"
        :class="['role-item', { 'active': selectedRoleId === role.id }]"
        @click="handleRoleClick(role)"
      >
        <div class="role-info">
          <!-- <i class="el-icon-user-solid"></i> -->
          <span class="role-title">{{ role.role_name }}</span>
        </div>
        <el-tag
          :type="role.role_status === 0 ? 'success' : 'danger'"
          size="mini"
        >{{ role.role_status === 0 ? '启用' : '禁用' }}</el-tag>
      </div>
    </div>

    <!-- 角色编辑抽屉 -->
    <el-drawer
      :title="roleDialogName"
      :visible.sync="roleDialogVisible"
      :close-on-click-modal="false"
      direction="rtl"
      size="600px"
    >
      <div style="padding: 20px;">
        <el-form ref="roleForm" :model="roleDialogForm" label-width="90px">
          <el-form-item label="状态:" required>
            <el-select
              v-model="roleDialogForm.role_status"
              placeholder="请选择"
              style="width: 100%;"
              clearable
            >
              <div v-for="(item, index) in roleStatusList" :key="index">
                <el-option :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="角色名称" required>
            <el-input clearable v-model="roleDialogForm.role_name"></el-input>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button size="small" @click="handleRoleDialogClose">取 消</el-button>
          <el-button size="small" type="primary" @click="saveRole">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  selectApi,
  addApi,
  updateApi,
  deleteApi
} from "@/services/systemPage/admin_role.js";

export default {
  name: "RoleManagement",
  props: {
    selectedRoleId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      roleList: [],
      roleStatusList: [
        { id: 0, name: "启用" },
        { id: 1, name: "禁用" }
      ],
      roleDialogName: "",
      roleDialogVisible: false,
      roleDialogForm: {},
      roleCheckedData: [],
      navData: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    isDeleteDisabled() {
      if (!this.selectedRoleId) return true;
      const role = this.roleList.find(r => r.id === this.selectedRoleId);
      return role && role.id === 1 && this.userInfo.role_id === 1;
    }
  },
  created() {
    this.navData = this.$store.state.navList;
    this.getRoleList();
  },
  methods: {
    /* 获取角色列表 */
    async getRoleList() {
      const { data, code } = await selectApi({
        pageNumber: 1,
        pageSize: 1000,
        createID: this.userInfo.createID
      });
      if (code === 200) {
        this.roleList = data;
      }
    },

    /* 点击角色 */
    handleRoleClick(role) {
      console.log("role", role);
      // 如果点击的是已选中的角色,则取消选中
      if (this.selectedRoleId === role.id) {
        this.$emit("role-select", null);
      } else {
        this.$emit("role-select", role);
      }
    },

    /* 新增角色 */
    handleAddRole() {
      this.roleDialogVisible = true;
      this.roleDialogName = "创建角色";
      this.roleDialogForm = {};
      this.roleCheckedData = [];
    },

    /* 删除角色 */
    handleDeleteRole() {
      if (!this.selectedRoleId) {
        this.$message.warning("请先选择一个角色");
        return;
      }
      const role = this.roleList.find(r => r.id === this.selectedRoleId);
      if (role) {
        this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            const res = await deleteApi({ id: role.id });
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
                  this.getRoleList();
                  // 通知父组件和其他组件（通过全局事件）角色列表已更新
                  this.$emit("role-delete", role.id);
                  this.$root.$emit('role-list-updated');
            }
          })
          .catch(() => {});
      }
    },

    /* 角色弹窗关闭 */
    handleRoleDialogClose() {
      if (this.$refs.roleTree) {
        this.$refs.roleTree.setCheckedKeys([]);
      }
      this.roleDialogVisible = false;
    },

    /* 角色树勾选变化 - 实现父子联动 */
    handleRoleTreeCheck(data, checked) {
      if (!this.$refs.roleTree) return;

      // 如果当前节点被选中
      if (checked.checkedKeys.includes(data.id)) {
        // 选中所有子节点
        this.checkAllChildrenInRoleTree(data, true);
      } else {
        // 取消选中所有子节点
        this.checkAllChildrenInRoleTree(data, false);
      }

      // 更新父节点状态
      this.updateParentStatusInRoleTree(data);
    },

    /* 递归选中/取消所有子节点（角色树） */
    checkAllChildrenInRoleTree(node, checked) {
      if (!node.children || node.children.length === 0) return;

      node.children.forEach(child => {
        if (checked) {
          this.$refs.roleTree.setChecked(child.id, true, false);
        } else {
          this.$refs.roleTree.setChecked(child.id, false, false);
        }
        // 递归处理子节点
        this.checkAllChildrenInRoleTree(child, checked);
      });
    },

    /* 更新父节点状态（角色树） */
    updateParentStatusInRoleTree(node) {
      // 找到父节点
      const parent = this.findParentNode(this.navData, node.id);
      if (!parent) return;

      // 检查所有子节点是否都被选中
      const allChildrenChecked = parent.children.every(child =>
        this.$refs.roleTree.getCheckedKeys().includes(child.id)
      );

      // 如果所有子节点都被选中，则选中父节点
      if (allChildrenChecked) {
        this.$refs.roleTree.setChecked(parent.id, true, false);
      }

      // 递归更新上级父节点
      this.updateParentStatusInRoleTree(parent);
    },

    /* 查找父节点 */
    findParentNode(nodes, childId) {
      for (let node of nodes) {
        if (
          node.children &&
          node.children.some(child => child.id === childId)
        ) {
          return node;
        }
        if (node.children) {
          const found = this.findParentNode(node.children, childId);
          if (found) return found;
        }
      }
      return null;
    },

    /* 保存角色 */
    async saveRole() {
      //必填字段校验
      if (
        !this.roleDialogForm.role_name ||
        (this.roleDialogForm.role_status !== 0 &&
          this.roleDialogForm.role_status !== 1)
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.roleDialogName === "创建角色") {
        const res = await addApi({
          ...this.roleDialogForm
        });
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "创建成功!"
          });
          this.roleDialogVisible = false;
          this.getRoleList();
          // 通知父组件和其他组件刷新角色列表
          this.$emit("role-update");
          this.$root.$emit('role-list-updated');
        }
      } else if (this.roleDialogName === "编辑角色") {
        const res = await updateApi({
          ...this.roleDialogForm
        });
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "编辑成功!"
          });
          this.roleDialogVisible = false;
          this.getRoleList();
          // 通知父组件和其他组件刷新角色列表
          this.$emit("role-update", this.roleDialogForm.id);
          this.$root.$emit('role-list-updated');
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.role-management {
  width: 280px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.panel-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
  // background: linear-gradient(135deg, #f6fff8 0%, #764ba2 100%);

  .panel-title {
    font-weight: 600;
    font-size: 16px;
    color: #282828;
  }
}

/* 角色操作按钮 */
.role-operations {
  padding: 15px;
  display: flex;
  gap: 8px;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;

  .el-button {
    flex: 1;
    font-size: 13px;
  }
}

/* 角色列表 */
.role-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dcdcdc;
    border-radius: 3px;

    &:hover {
      background: #c0c0c0;
    }
  }
}

.role-item {
  padding: 14px 16px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;

  &:hover {
    border-color: #f6fff8;
    background-color: #f6fff8;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
    transform: translateY(-1px);
  }

  &.active {
    border-color: #65d27d;
    background: #f6fff8;
    box-shadow: 0 2px 12px rgba(220, 255, 162, 0.25);

    .role-title {
      color: #f6fff8;
      font-weight: 600;
    }
  }

  .role-info {
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      color: #f6fff8;
      font-size: 16px;
    }

    .role-title {
      font-weight: 500;
      font-size: 14px;
      color: #333;
    }
  }
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
}
</style>
